const references = [
  {
    title: 'Rénovation complète — Villa Neuenegg',
    category: 'Rénovation complète',
    location: 'Neuenegg, Fribourg',
    duration: '6 semaines',
    description: 'Transformation totale d\'une villa des années 80 : cuisine ouverte, salle de bain moderne, parquet chêne, peinture intégrale et isolation des combles.',
    before: 'https://readdy.ai/api/search-image?query=old%20outdated%20kitchen%20bathroom%20living%20room%20before%20renovation%20Switzerland%201980s%20worn%20tiles%20dark%20walls%20dated%20furniture%20needs%20renovation&width=600&height=400&seq=ref-before-01&orientation=landscape',
    after: 'https://readdy.ai/api/search-image?query=stunning%20modern%20renovated%20kitchen%20open%20plan%20living%20room%20Switzerland%20white%20walls%20oak%20parquet%20floor%20bright%20natural%20light%20elegant%20minimalist%20after%20renovation&width=600&height=400&seq=ref-after-01&orientation=landscape',
    testimonial: 'CasaReNovaPlus a transformé notre maison au-delà de nos espérances. Travail soigné, délais respectés.',
    client: 'Famille Müller, Neuenegg',
  },
  {
    title: 'Salle de bain — Appartement Fribourg',
    category: 'Salle de bain',
    location: 'Fribourg',
    duration: '2 semaines',
    description: 'Rénovation complète d\'une salle de bain : douche à l\'italienne, carrelage grand format, meuble vasque suspendu, éclairage LED encastré.',
    before: 'https://readdy.ai/api/search-image?query=old%20bathroom%20before%20renovation%20outdated%20tiles%20bathtub%20worn%20fixtures%20Switzerland%20apartment%20needs%20update&width=600&height=400&seq=ref-before-02&orientation=landscape',
    after: 'https://readdy.ai/api/search-image?query=luxury%20modern%20bathroom%20renovation%20walk-in%20shower%20large%20format%20tiles%20floating%20vanity%20LED%20lighting%20Switzerland%20elegant%20white%20minimal%20after&width=600&height=400&seq=ref-after-02&orientation=landscape',
    testimonial: 'Résultat impeccable, on a l\'impression d\'être dans un hôtel 5 étoiles. Merci CasaReNovaPlus !',
    client: 'M. Schneider, Fribourg',
  },
  {
    title: 'Cuisine ouverte — Maison Berne',
    category: 'Cuisine',
    location: 'Berne',
    duration: '3 semaines',
    description: 'Abattage d\'une cloison pour créer une cuisine ouverte sur le salon. Plan de travail en quartz, îlot central, électroménager Bosch intégré.',
    before: 'https://readdy.ai/api/search-image?query=closed%20old%20kitchen%20before%20renovation%20Switzerland%20small%20dark%20separate%20room%20outdated%20cabinets%20needs%20modernization&width=600&height=400&seq=ref-before-03&orientation=landscape',
    after: 'https://readdy.ai/api/search-image?query=beautiful%20open%20plan%20modern%20kitchen%20island%20quartz%20countertop%20integrated%20appliances%20bright%20Switzerland%20after%20renovation%20elegant%20contemporary&width=600&height=400&seq=ref-after-03&orientation=landscape',
    testimonial: 'Notre maison est méconnaissable ! L\'équipe a été professionnelle du début à la fin.',
    client: 'Famille Gerber, Berne',
  },
  {
    title: 'Rénovation façade — Immeuble Vaud',
    category: 'Façade & Isolation',
    location: 'Vaud',
    duration: '4 semaines',
    description: 'Ravalement complet de façade avec isolation thermique par l\'extérieur (ITE). Économies d\'énergie de 35% constatées après travaux.',
    before: 'https://readdy.ai/api/search-image?query=old%20building%20facade%20before%20renovation%20Switzerland%20cracked%20plaster%20weathered%20exterior%20needs%20renovation&width=600&height=400&seq=ref-before-04&orientation=landscape',
    after: 'https://readdy.ai/api/search-image?query=modern%20renovated%20building%20facade%20Switzerland%20fresh%20plaster%20insulation%20clean%20exterior%20contemporary%20look%20after%20renovation&width=600&height=400&seq=ref-after-04&orientation=landscape',
    testimonial: 'Excellent travail sur notre immeuble. Les économies d\'énergie sont au rendez-vous.',
    client: 'Copropriété Les Pins, Vaud',
  },
  {
    title: 'Parquet & Peinture — Appartement Neuchâtel',
    category: 'Parquet & Peinture',
    location: 'Neuchâtel',
    duration: '1 semaine',
    description: 'Pose de parquet chêne massif huilé dans tout l\'appartement, peinture intégrale en blanc cassé, plinthes et baguettes de finition.',
    before: 'https://readdy.ai/api/search-image?query=old%20apartment%20before%20renovation%20worn%20carpet%20dark%20paint%20Switzerland%20needs%20update%20flooring%20walls&width=600&height=400&seq=ref-before-05&orientation=landscape',
    after: 'https://readdy.ai/api/search-image?query=bright%20renovated%20apartment%20oak%20hardwood%20floor%20white%20walls%20Switzerland%20elegant%20minimal%20after%20renovation%20warm%20natural%20light&width=600&height=400&seq=ref-after-05&orientation=landscape',
    testimonial: 'Travail rapide et propre. L\'appartement est lumineux et moderne. Je recommande vivement.',
    client: 'Mme Favre, Neuchâtel',
  },
  {
    title: 'Aménagement combles — Maison Valais',
    category: 'Aménagement',
    location: 'Valais',
    duration: '5 semaines',
    description: 'Transformation de combles perdus en suite parentale avec salle de bain, dressing et bureau. Isolation, cloisons, électricité et finitions.',
    before: 'https://readdy.ai/api/search-image?query=empty%20attic%20space%20before%20renovation%20Switzerland%20raw%20unfinished%20roof%20beams%20insulation%20needed&width=600&height=400&seq=ref-before-06&orientation=landscape',
    after: 'https://readdy.ai/api/search-image?query=beautiful%20converted%20attic%20bedroom%20suite%20Switzerland%20sloped%20ceiling%20wooden%20beams%20cozy%20elegant%20after%20renovation%20warm%20light&width=600&height=400&seq=ref-after-06&orientation=landscape',
    testimonial: 'Nos combles sont devenus notre pièce préférée ! Qualité irréprochable.',
    client: 'Famille Bonvin, Valais',
  },
];

export default function RenovationReferences() {
  return (
    <section id="references" className="py-24 bg-gray-950">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 bg-teal-500/20 border border-teal-500/30 rounded-full px-4 py-2 mb-5">
            <i className="ri-image-line text-teal-400 text-sm"></i>
            <span className="text-teal-300 text-sm font-medium">Nos réalisations</span>
          </div>
          <h2 className="text-4xl font-black text-white mb-4">
            Références &<br />
            <span className="text-teal-400">projets réalisés</span>
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto text-base leading-relaxed">
            Découvrez nos transformations avant/après. Chaque projet est unique et réalisé avec le même niveau d'exigence et de savoir-faire.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {references.map((ref, i) => (
            <div key={i} className="bg-white/5 border border-white/8 rounded-2xl overflow-hidden hover:border-white/20 transition-all duration-300 hover:-translate-y-1">
              {/* Before/After images */}
              <div className="grid grid-cols-2 h-48">
                <div className="relative overflow-hidden">
                  <img src={ref.before} alt={`Avant - ${ref.title}`} className="w-full h-full object-cover object-top" />
                  <div className="absolute inset-0 bg-black/40"></div>
                  <span className="absolute bottom-2 left-2 bg-red-500/80 text-white text-xs font-bold px-2 py-0.5 rounded">AVANT</span>
                </div>
                <div className="relative overflow-hidden">
                  <img src={ref.after} alt={`Après - ${ref.title}`} className="w-full h-full object-cover object-top" />
                  <div className="absolute inset-0 bg-black/10"></div>
                  <span className="absolute bottom-2 right-2 bg-emerald-500/80 text-white text-xs font-bold px-2 py-0.5 rounded">APRÈS</span>
                </div>
              </div>

              <div className="p-5">
                <div className="flex items-center justify-between mb-3">
                  <span className="text-xs font-semibold text-emerald-400 bg-emerald-500/10 px-2 py-1 rounded-full">{ref.category}</span>
                  <div className="flex items-center gap-1 text-xs text-gray-500">
                    <i className="ri-map-pin-line"></i>
                    <span>{ref.location}</span>
                  </div>
                </div>
                <h3 className="text-white font-bold text-sm mb-2">{ref.title}</h3>
                <p className="text-gray-400 text-xs leading-relaxed mb-4">{ref.description}</p>

                <div className="flex items-center gap-2 mb-3">
                  <i className="ri-time-line text-gray-500 text-xs"></i>
                  <span className="text-gray-500 text-xs">Durée : {ref.duration}</span>
                </div>

                {/* Testimonial */}
                <div className="bg-white/5 rounded-xl p-3 border border-white/8">
                  <div className="flex gap-1 mb-2">
                    {[...Array(5)].map((_, j) => (
                      <i key={j} className="ri-star-fill text-amber-400 text-xs"></i>
                    ))}
                  </div>
                  <p className="text-gray-300 text-xs italic leading-relaxed mb-1">&ldquo;{ref.testimonial}&rdquo;</p>
                  <p className="text-gray-500 text-xs font-medium">— {ref.client}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-gray-500 text-sm mb-4">Vous avez un projet similaire ?</p>
          <a
            href="#contact"
            className="inline-flex items-center gap-2 bg-emerald-500 hover:bg-emerald-600 text-white font-semibold px-8 py-4 rounded-lg transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-line"></i>
            Demander un devis gratuit
          </a>
        </div>
      </div>
    </section>
  );
}
